import React from 'react';
import { Link } from 'react-router-dom';

import line1 from '../../../assets/img/lines/11.png';
import line2 from '../../../assets/img/lines/12.png';
import co1 from '../../../assets/img/companies/1.png';
// import co2 from '../../../assets/img/companies/2.jpeg';
import co3 from '../../../assets/img/companies/3.png';
import co4 from '../../../assets/img/companies/4.png';
import co5 from '../../../assets/img/companies/5.jpeg';
import co6 from '../../../assets/img/companies/6.jpeg';
import co7 from '../../../assets/img/companies/7.jpeg';
import co8 from '../../../assets/img/companies/8.jpeg';
import co9 from '../../../assets/img/companies/9.jpeg';
import co10 from '../../../assets/img/companies/10.jpeg';
import co11 from '../../../assets/img/companies/11.png';
import co12 from '../../../assets/img/companies/12.jpeg';
import co13 from '../../../assets/img/companies/13.png';
import co14 from '../../../assets/img/companies/14.png';
import co15 from '../../../assets/img/companies/15.png';
import co16 from '../../../assets/img/companies/16.png';

const serviceblock = [
    { icon: co1, title: 'Zimworx', link: 'https://www.zimworx.com' },
    // { icon: co2, title: 'DrFinanceGroup', link: 'https://www.drfinancegroup.com' },
    { icon: co3, title: 'GlobalImpactNow', link: 'https://www.globalimpact-now.com' },
    { icon: co4, title: 'GlobalImaging', link: 'https://www.globalimagingresources.com' },
    { icon: co5, title: 'SupportDDS', link: 'https://www.supportdds.com' },
    { icon: co6, title: 'WadeAMG', link: 'https://www.wadeamg.com' },
    { icon: co7, title: 'We Support Ministries', link: 'https://www.wesupportministries.com' },
    { icon: co8, title: 'LuxuryRental Properties', link: '/properties' },
    { icon: co9, title: 'SupportCPA', link: 'https://www.supportcpa.com' },
    { icon: co10, title: 'SupportChiro', link: 'https://www.supportchiro.com' },
    { icon: co11, title: 'SimbaSupport', link: 'https://www.simbasupport.com' },
    { icon: co12, title: 'SupportDRS', link: 'https://www.supportdrs.com' },
    { icon: co15, title: 'InSource, Don\'t Outsource', link: 'https://www.zimworx.com/podcasts' },
    { icon: co14, title: 'Love My EA', link: 'https://www.lovemyea.com' },
    { icon: co16, title: 'Global Impact Podcast', link: 'https://www.zimworx.com/podcasts' },
    { icon: co13, title: 'ZimboJobs', link: 'https://www.zimbojobs.com' },
]

function Service(props) {
    return (
        <section className="service-section grey-bg service-line-shape section-gap" style={{ backgroundColor: "white"}}>
            <div className="container">
                {/* Section Title */}
                <div className="section-title text-center both-border mb-50">
                    <span className="title-tag">Affiliated Companies</span>
                    <h2 className="title">With 30+ years experience <br /> managing several businesses</h2>
                    <p>JW Oliver
                        helps aspiring and established business owners leverage remote workforces and
                        how this practice is revolutionizing the business environment.</p>
                </div>
                {/* Services Boxes */}
                <div className="row service-boxes justify-content-center">
                    {serviceblock.map((item, i) => (
                        <div key={i} className="col-lg-4 col-sm-6 col-10 wow fadeInRight" data-wow-duration="1500ms" data-wow-delay="700ms">

                            <div className="service-box-three border-0">
                                <a href={item.link} target="_blank" rel="noopener noreferrer">
                                    <div className="icon">
                                        <img src={item.icon} alt="" />
                                    </div>
                                    <h3><Link to="/companies">{item.title}</Link></h3>
                                    {/* <p>{item.text}</p> */}

                                    {/* <Link to="/companies" className="service-link">
                                    <i className="fal fa-long-arrow-right" />
                                </Link> */}

                                </a>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <div className="line-one">
                <img src={line2} alt="line-shape" />
            </div>
            <div className="line-two">
                <img src={line1} alt="line-shape" />
            </div>
        </section>
    );
}

export default Service;